var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiffSelection = function SvgDiffSelection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5F677E",
    d: "M12.468 2.957a.795.795 0 0 1-1.123 0l-.246-.246v.784c0 1.3-.268 2.282-.818 3.004-.501.655-1.13.98-1.689 1.265-.903.464-1.448.744-1.448 2.31v1.832a.793.793 0 1 1-1.587 0v-1.833c0-1.565-.546-1.845-1.448-2.31-.558-.284-1.188-.61-1.69-1.264-.55-.722-.818-1.704-.818-3.004v-.784l-.245.246A.795.795 0 0 1 .232 1.833l1.6-1.6a.79.79 0 0 1 1.12 0l1.6 1.6a.795.795 0 0 1-.56 1.357.78.78 0 0 1-.56-.233l-.246-.246v.784c0 2.012.69 2.366 1.644 2.857.501.258 1.066.549 1.518 1.087.451-.538 1.017-.831 1.518-1.087.954-.488 1.644-.843 1.644-2.857v-.784l-.246.246a.793.793 0 1 1-1.12-1.124l1.599-1.6a.79.79 0 0 1 1.12 0l1.6 1.6a.79.79 0 0 1 .005 1.124"
  })));
};
export default SvgDiffSelection;